module.exports = __webpack_public_path__ + "img/tab1.fb6731d2.png";